export { default as CubeOutline } from './CubeOutline'
